import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { Loading } from "ComponentsUI/TarifficationB";
import { variablesFromRouter } from "Services/QueryBuilder";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import Button from "ComponentsUI/Button";
import Routes from "Configs/routes";
import { BigBlockStub } from "Layouts/Stubs";
import PlanBContainer from "Containers/PlanBContainer";
import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
import { getPhoneNumberByCode } from "Utils/siteConfig";

const LIMIT = 15;

@inject("ApplicationModel")
@observer
class TarifficationsContainer extends React.Component {
	constructor(props) {
		super(props);
		this.initTariffsForPopup = !this.props.initTariffsForPopup;
	}

	componentWillUnmount() {
		let {
			ApplicationModel: { fixedPanelModel },
		} = this.props;
		fixedPanelModel.setShowGiftWidget(true);
	}

	componentDidMount() {
		let {
			ApplicationModel: { fixedPanelModel },
		} = this.props;
		fixedPanelModel.setShowGiftWidget(false);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!this.initTariffsForPopup) {
			if (!!this.props.pagination) {
				!!this.props.initTariffsForPopup &&
					this.props.initTariffsForPopup(this.props.pagination.items_total);
				this.initTariffsForPopup = true;
			}
		}
	}

	getSnapshotBeforeUpdate() {
		return {
			scrollYPosition: window.scrollY || window.scrollTop,
		};
	}

	resetFilters() {
		const {
			match: { params },
		} = this.props;
		const providersUrl = this.props.new_house_url
			? generateUrl(Routes.RatesInHouse.route, {
					regionUrl: params.regionUrl,
					house_url: params.house_url,
					house_id: params.house_id,
				})
			: generateUrl(Routes.Rates.route, {
					regionUrl: params.regionUrl,
				});

		this.props.history.push({
			pathname: providersUrl,
		});
	}

	render() {
		const {
			ApplicationModel: { windowSizeModel, text },
			tariffs,
			pagination,
			isLoading,
		} = this.props;

		if (!tariffs) {
			return (
				<>
					<BigBlockStub />
				</>
			);
		}

		let pageTotal = 0;
		let page = 1;
		let path = "";

		if (pagination) {
			pageTotal = Math.ceil(pagination.items_total / LIMIT);
			if (this.props.match.params.page) {
				page = +this.props.match.params.page;
			}
			path = this.props.new_house_url
				? generateUrl(Routes.RatesInHouse.route, {
						regionUrl: this.props.match.params.regionUrl,
						house_url: this.props.match.params.house_url,
						house_id: this.props.match.params.house_id,
					})
				: generateUrl(Routes.DomaNzl.route, {
						regionUrl: this.props.match.params.regionUrl,
						search: this.props.location.search,
					});
		}

		const siteCode = this.props.ApplicationModel.siteCode;
		const phoneNumber = getPhoneNumberByCode(siteCode);

		function displayOopsText() {
			return (
				<div>
					Похоже, что по Вашему запросу нет подходящих тарифов. Попробуйте сбросить значения
					фильтров. Или позвоните нам по номеру{" "}
					<span style={{ whiteSpace: "nowrap" }}>{phoneNumber}</span> и оператор вас
					проконсультирует!
				</div>
			);
		}

		if (!tariffs.length) {
			return (
				<Container>
					<Row>
						<Col
							lg={{ size: 4, offset: 4 }}
							md={{ size: 4, offset: 4 }}
							sm={{ size: 4, offset: 4 }}
							xs={{ size: 6, offset: 3 }}
						>
							<EmptyStub
								header={text.OOPS}
								text={displayOopsText()}
								icon={
									<span
										className="icon48 icon-hearts"
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
									/>
								}
								button={
									<Button
										typeText={"small"}
										size={"low"}
										status={"withoutAccent"}
										onClick={() => this.resetFilters()}
									>
										<span
											className="icon48 icon-playlist-add"
											style={{
												fontSize: "24px",
												color: "#d3cee1",
											}}
										/>
										{text.RESET_FILTERS}
									</Button>
								}
							/>
						</Col>
					</Row>
				</Container>
			);
		}

		return (
			<>
				{/* <PaddingBottom> */}
				<PlanBContainer
					tariffs={tariffs}
					useYandexEvent={this.props.useYandexEvent}
					isTS={this.props.isTS}
					addFormOneClick={this.props.addFormOneClick}
					pageName="tc"
					dataTest="countRates"
				/>
				{pagination && (
					<div style={{ paddingTop: "15px" }}>
						<Paginator
							key={23}
							itemsTotal={pagination.items_total}
							itemsPerPage={LIMIT}
							pageCurrent={page}
							pageTotal={pageTotal}
							windowSizes={windowSizeModel.windowSizes}
							urlDefault={path}
							wrapperItem={<PaginatorElem />}
							location={this.props.location}
							datatest="tariffs"
						/>
					</div>
				)}
				{isLoading && <Loading text={text.LOADING_TARIFFS} />}
				{/* </PaddingBottom> */}
			</>
		);
	}
}

export default withRouter(withDefaultParams(variablesFromRouter(TarifficationsContainer)));
